import PageHeader from '@/components/Common/UI/PageHeader';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import PeopleIcon from '@mui/icons-material/People';
import TimerIcon from '@mui/icons-material/Timer';
import { Box } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';
import ROUTES from '../../../../routes/ROUTES';
import { tokens } from '../../../../theme/tokens';

const NAV_ITEMS = [
  // { id: 'taxonomy', label: 'Taxonomy', path: ROUTES.SUPPORT.TAXONOMY, icon: CategoryIcon },
  { id: 'macros', label: 'Response macros', path: ROUTES.SUPPORT.MACROS, icon: FormatListBulletedIcon },
  // { id: 'templates', label: 'Templates', path: ROUTES.SUPPORT.TEMPLATES, icon: DescriptionIcon },
  { id: 'sla', label: 'SLA rules', path: ROUTES.SUPPORT.SLA, icon: TimerIcon },
  // { id: 'alerts', label: 'Alerts', path: ROUTES.SUPPORT.ALERTS, icon: NotificationsActiveIcon },
  { id: 'agents', label: 'Agents', path: ROUTES.SUPPORT.AGENTS, icon: PeopleIcon },
  // { id: 'integrations', label: 'Integrations', path: ROUTES.SUPPORT.INTEGRATIONS, icon: IntegrationInstructionsIcon },
];

export default function SettingsLayout() {
  const location = useLocation();

  return (
    <>
      {/* Page header */}
      <Box sx={{ mb: 3 }}>
        <PageHeader title={"Settings"} sx={{ p: 0 }} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '220px 1fr' },
          gap: 3,
          alignItems: 'flex-start',
        }}
      >
        {/* Aside nav (md+) / horizontal scroll tabs (below md) */}
        <Box
          component="aside"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row', md: 'column' },
            gap: 0.5,
            position: { md: 'sticky' },
            top: { md: 16 },
            alignSelf: 'flex-start',
            overflowX: { xs: 'auto', md: 'visible' },
            pb: { xs: 1, md: 0 },
            mx: { xs: -1, md: 0 },
            px: { xs: 1, md: 0 },
            // hide scrollbar visually on mobile but keep functional
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {NAV_ITEMS.map((t) => {
            const Icon = t.icon;
            const active = location.pathname === t.path;
            const Component = t.disabled ? 'div' : Link;

            return (
              <Box
                key={t.id}
                component={Component}
                to={t.disabled ? undefined : t.path}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1.25,
                  px: 1.5,
                  py: 1.125,
                  borderRadius: `${tokens.radius.base}px`,
                  cursor: t.disabled ? 'default' : 'pointer',
                  whiteSpace: 'nowrap',
                  textDecoration: 'none',
                  bgcolor: active ? tokens.color.primary16 : 'transparent',
                  color: active ? tokens.color.primary : tokens.color.textMedium,
                  fontWeight: active ? 600 : 500,
                  fontSize: 14,
                  opacity: t.disabled ? 0.5 : 1,
                  transition: 'all 0.18s ease',
                  '&:hover': {
                    bgcolor: active ? tokens.color.primary16 : tokens.color.primary08,
                  },
                }}
              >
                <Icon sx={{ fontSize: 18, color: active ? tokens.color.primary : tokens.color.textSecondary }} />
                {t.label}
              </Box>
            );
          })}
        </Box>

        {/* Content Area */}
        <Box sx={{ minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
}
